/*
 * @Author: yaoyuting
 * @Date: 2019-08-30 02:02:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-02 17:10:17
 * @Descripttion:
 */
import Vue from 'vue';
import Router from 'vue-router';
import {
  goPAGE,
} from './utils/utils';

Vue.use(Router);

const classify = goPAGE();
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: `/${classify}/Index`,
  }, {
    path: '/pc',
    name: 'home',
    component: () => import('./views/pc/Home'),
    children: [
      {
        path: '/pc/Index',
        name: 'Index',
        component: () => import('./views/pc/Index'),
      },
      {
        path: '/pc/Do',
        name: 'Do',
        component: () => import('./views/pc/Do'),
      }, {
        path: '/pc/Dao',
        name: 'Dao',
        component: () => import('./views/pc/Dao'),
      }, {
        path: '/pc/Technical',
        name: 'Technical',
        component: () => import('./views/pc/Technical'),
      }, {
        path: '/pc/Partners',
        name: 'Partners',
        component: () => import('./views/pc/Partners'),
      }, {
        path: '/pc/NetIntro',
        name: 'NetIntro',
        component: () => import('./views/pc/intro/NetIntro'),
      }, {
        path: '/pc/NetOver',
        name: 'NetOver',
        component: () => import('./views/pc/intro/NetOver'),
      }, {
        path: '/pc/Token',
        name: 'Token',
        component: () => import('./views/pc/intro/Token'),
      }, {
        path: '/pc/Client',
        name: 'Client',
        component: () => import('./views/pc/intro/Client'),
      }, {
        path: '/pc/Browser',
        name: 'Browser',
        component: () => import('./views/pc/intro/Client'),
      },
      {
        path: '/pc/Common',
        name: 'Common',
        component: () => import('./views/pc/intro/Common'),
      }, {
        path: '/pc/Econimucs',
        name: 'Econimucs',
        component: () => import('./views/pc/intro/Econimucs'),
      }, {
        path: '/pc/Organization',
        name: 'Organization',
        component: () => import('./views/pc/intro/Organization'),
      }, {
        path: '/pc/DAOFund',
        name: 'DAOFund',
        component: () => import('./views/pc/intro/DAOFund'),
      },
      {
        path: '/pc/Blog',
        name: 'Blog',
        component: () => import('./views/pc/intro/Blog'),
      },
      {
        path: '/pc/BlogDetails',
        name: 'BlogDetails',
        component: () => import('./views/pc/intro/BlogDetails'),
      },
      {
        path: '/pc/Login',
        name: 'Login',
        component: () => import('./views/pc/pro/Login'),
      },{
        path: '/pc/Register',
        name: 'Register',
        component: () => import('./views/pc/pro/Register'),
      },{
        path: '/pc/Forgot',
        name: 'Forgot',
        component: () => import('./views/pc/pro/Forgot'),
      },{
        path: '/pc/Proposal',
        name: 'Proposal',
        component: () => import('./views/pc/pro/Proposal'),
      },{
        path: '/pc/Publish',
        name: 'Publish',
        component: () => import('./views/pc/pro/Publish'),
      },
      // 技术路线图
      {
        path: '/pc/TechRoadmap',
        name: 'TechRoadmap',
        component: () => import('./views/pc/tech/TechRoadmap'),
      },
      {
        path: '/pc/TechRoadmapSwiper',
        name: 'TechRoadmapSwiper',
        component: () => import('./views/pc/tech/TechRoadmapSwiper'),
      },
      // 提案页面
     {
         path: '/pc/Details',
        name: 'Details',
        component: () => import('./views/pc/pro/Details'),
      },
      {
        path: '/pc/BindWallet',
        name: 'BindWallet',
        component: () => import('./views/pc/pro/Bindwallet'),
      },
    ],
  }, {
    path: '/m',
    name: 'home',
    component: () => import('./views/m/Home'),
    children: [
      {
        path: '/m/Index',
        name: 'Index',
        component: () => import('./views/m/Index'),
      }, {
        path: '/m/Do',
        name: 'Do',
        component: () => import('./views/m/Do'),
      }, {
        path: '/m/Dao',
        name: 'Dao',
        component: () => import('./views/m/Dao'),
      }, {
        path: '/m/Technical',
        name: 'Technical',
        component: () => import('./views/m/Technical'),
      }, {
        path: '/m/Partners',
        name: 'Partners',
        component: () => import('./views/m/Partners'),
      }, {
        path: '/m/Intro',
        name: 'NetIntro',
        component: () => import('./views/m/intro/NetIntro'),
      },
      {
        path: '/m/NetOver',
        name: 'NetOver',
        component: () => import('./views/m/intro/NetOver'),
      },
      {
        path: '/m/Token',
        name: 'Token',
        component: () => import('./views/m/intro/Token'),
      }, {
        path: '/m/Eco',
        name: 'Econimucs',
        component: () => import('./views/m/intro/Econimucs'),
      }, {
        path: '/m/Client',
        name: 'Client',
        component: () => import('./views/m/intro/Client'),
      }, {
        path: '/m/Wave',
        name: 'Wave',
        component: () => import('./views/m/intro/Wave'),
      }, {
        path: '/m/Fund',
        name: 'Fund',
        component: () => import('./views/m/intro/Fund'),
      }, {
        path: '/m/Blog',
        name: 'Blog',
        component: () => import('./views/m/inter/Blog'),
        meta:{
          keepAlive: true,//列表页加入缓存
          isBack: false,//判断是否要加载数据的依据
        }
      }, {
        path: '/m/BlogDetail',
        name: 'BlogDetail',
        component: () => import('./views/m/inter/BlogDetail'),
      }, {
        path: '/m/NetDao',
        name: 'DAO',
        component: () => import('./views/m/intro/NetDao'),
      },
      // 提案
      // {
      //   path: '/m/InitProposal',
      //   name: 'InitProposal',
      //   component: () => import('./views/m/proposal/InitProposal.vue'),
      // },
      //登录注册
      /* {
        path: '/m/Login',
        name: 'Login',
        component: () => import('./views/m/intro/Login.vue'),
      },
      {
        path: '/m/Register',
        name: 'Register',
        component: () => import('./views/m/intro/Register.vue'),
      }, */
      // 技术路线图
      {
        path: '/m/TechRoadmap',
        name: 'TechRoadmap',
        component: () => import('./views/m/tech/TechRoadmap.vue'),
      },
    ],
  },
  ],
});
